import { Column, ModelBase } from 'loca-boot-core'

/**
 * 加电资源概览
 */
export class LocationModel extends ModelBase {
  /**
   * ID
   */
  @Column({ name: 'pid' })
  id!: string
  /**
   * 名称
   */
  @Column({ name: 'poi' })
  name!: string
  /**
   * 行政区划码
   */
  @Column({ name: 'area_code' })
  code!: string
  /**
   * 经度
   */
  @Column({ name: 'poi_longitude' })
  lng!: number
  /**
   * 纬度
   */
  @Column({ name: 'poi_latitude' })
  lat!: number
  /**
   * 地址
   */
  @Column({ name: 'address' })
  address!: string
  /**
   * 省
   */
  @Column({ name: 'province' })
  province!: string
  /**
   * 市
   */
  @Column({ name: 'city' })
  city!: string
  /**
   * 区
   */
  @Column({ name: 'district' })
  district!: string
  /**
   * 街道
   */
  @Column({ name: 'town' })
  town!: string
  /**
   * 村庄
   */
  @Column({ name: 'village' })
  village!: string
  /**
   * 道路
   */
  @Column({ name: 'road_name' })
  road!: string

  /**
   * 资源点类型 20231221新增
   * RECHARGE :recharge 充换电资源 NIO_STORE :nio_store 蔚来门店资源 TEST_DRIVE :test_drive 试驾点资源
   */
  @Column()
  public pointType!: string

  /**
   * 资源点子类型 20231221新增
   * POWER_SWAP :PowerSwap 换电站资源 CHARGE_STATION :ChargeStation 充电站资源 NIO_SPACE :NioSpace 蔚来空间 NIO_HOUSE :NioHouse 蔚来中心 TEST_DRIVE :TestDrive 试驾点
   */
  @Column()
  public pointSubType!: string
}
